
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.103 13.9329L24.0361 11.7066C23.3635 11.3273 22.7468 10.8695 22.2013 10.3446C20.4744 8.67588 18.8899 7.86343 16.2434 8.01875L10.9764 8.45285L10.713 8.50861C9.98453 8.65839 9.45436 9.23874 9.41781 9.9264L9.12424 15.1794C9.08837 15.8535 9.61844 16.4406 10.3437 16.5299C11.0689 16.6193 11.7474 16.1811 11.9046 15.5219L12.768 11.7544L14.5683 11.611C14.5683 11.611 12.8414 17.7043 12.8069 17.8796L11.9132 21.5555L6.11509 23.5667C5.11766 23.8862 4.58233 24.8846 4.91233 25.8098C5.24233 26.735 6.3157 27.2451 7.32393 26.9558L14.5381 25.0721C15.2151 24.8897 15.7483 24.4068 15.9585 23.7857L16.0103 23.6304L17.0205 20.5041L19.6109 23.4591L19.7663 30.1777C19.7485 31.1675 20.6038 31.9832 21.6767 31.9997C22.7497 32.0162 23.634 31.2272 23.6519 30.2375L24.1095 22.7463C24.1328 22.3358 24.0083 21.9298 23.7555 21.5913L23.6605 21.4679L21.1565 18.1424C21.5192 17.2503 22.02 15.9082 22.4517 14.5143L26.6654 16.3901C27.3924 16.699 28.2545 16.4331 28.6338 15.7828C29.0131 15.1326 28.7787 14.3224 28.0987 13.9329H28.103Z","fill":"white"}}),_c('path',{attrs:{"d":"M21.7701 7.77547C23.3881 8.31012 25.1877 7.8707 26.3287 6.6624C27.4697 5.4541 27.727 3.71527 26.9804 2.25781C26.2338 0.800348 24.6306 -0.0882373 22.9195 0.00695613C21.2083 0.10215 19.7267 1.16234 19.1664 2.69251C18.4038 4.77502 19.5681 7.04783 21.7701 7.77547Z","fill":"white"}})])
          )
        }
      }
    